import React, { useEffect, useState } from "react";
import Card from "components/card";
import { columnsDataCheck } from "../tables/variables/columnsData";
import CheckTable from "../tables/components/CheckTable";
import { useDispatch, useSelector } from "react-redux";
import { getAppListThunk } from "slices/userSlice";
import AddAppModal from "components/modals/addAppModal";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import { deleteAppThunk } from "slices/userSlice";
import { notify } from "common/toastUtil";
import PopUpAlertModal from "components/modals/popUpAlertModal";

const AppsPage = () => {
    const appList = useSelector((state) => state?.users?.appList) || [];
    const appdelete = useSelector((state) => state?.users?.data);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [singleData, setSingleData] = React.useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [openAlert, setOpenAlert] = useState(false);
    const [id,setId]= useState("");
    const [dataTable, setDataTable] = useState(appList || []);
const itemsPerPage = 5; // adjust as needed
const indexLast = currentPage * itemsPerPage;
const indexFirst = indexLast - itemsPerPage;
const currentApps = dataTable?.slice(indexFirst, indexLast);

    const totalPages = Math.ceil(dataTable?.length / itemsPerPage);
    useEffect(() => {
        dispatch(getAppListThunk());
    }, []);
    const deleteApp = (id) => {
        setId(id);
        setOpenAlert(true);

    }

    useEffect(() => {
        if (appList?.length > 0) {
            setDataTable(appList);
        }
    }
        , [appList, appdelete?.status]);
            useEffect(() => {
        if (appdelete?.status === 200 && id && appdelete?.message=="Admin deleted successfully") {
            notify("success", appdelete?.message);
            setOpenAlert(false);
            dispatch(getAppListThunk());


        }
        if (appdelete?.status !== 200 && appdelete?.status !==201) {
            notify("error", appdelete?.message);
        }
    }, [appdelete?.status,dispatch,appdelete?.message,id]);
    return (
        <>
        <div className="flex justify-around w-full mt-4">
          <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
            Total App Count: {appList?.length ?? 0}
          </Card>
        
          <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
            Active App Count: {appList?.filter(item => !item.isDeleted)?.length ?? 0}
          </Card>
        
          <Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold">
            Inactive Gateway Count:  {appList?.filter(item => item.isDeleted)?.length ?? 0}
          </Card>
        
        </div>
        <PopUpAlertModal openAlert={openAlert} setOpenAlert={setOpenAlert} title="Are you sure you want to delete this app?" clickHandler={()=>dispatch(deleteAppThunk(id))} />
        <AddAppModal open={open} setOpen={setOpen} singleData={singleData} setSingleData={setSingleData} />
            <Card extra="mt-3 !z-5 overflow-hidden">
                <div className="relative w-full flex items-center justify-end rounded-t-3xl p-3">
                    <button onClick={() => setOpen(true)}
                        className=" top-3 right-3 flex items-center justify-center rounded-[9px] bg-[#422afb] p-2 text-white hover:cursor-pointer"
                    >
                        Register New App
                    </button>


                </div>
            </Card>
            <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">

                {currentApps?.length >0 && <CheckTable deleteApp={deleteApp} setOpen={setOpen} setSingleData={setSingleData} columnsData={columnsDataCheck} tableData={currentApps} />}
                <div className="flex gap-2 justify-center my-4">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((p) => p - 1)}
  >
    <MdSkipPrevious />
  </button>

  {[...Array(totalPages)].map((_, i) => {
    const page = i + 1;
    return (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        className={page === currentPage ? 'font-bold' : ''}
      >
        {page}
      </button>
    );
  })}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage((p) => p + 1)}
  >
<MdSkipNext />
  </button>
</div>

            </div>
        </>

    );
};

export default AppsPage;
